import { EntityId } from '@factorialco/f0-react/dist/experimental'

// Type conversion helpers for workflow values
/**
 * Converts the value coming from any Input (String, Number, null) to a string
 * Number values will not be localized
 */
export const convertToWorkflowValue = (value: string | number | null): string => {
  if (value === null) return ''
  if (typeof value === 'string') return value
  if (typeof value === 'number') return value.toString() //for numbers will always use dot (.) for decimal separator
  return ''
}

/**
 * Converts the value coming from workflow expression (String) to a number
 */
export const convertNumberFromWorkflow = (value: string | undefined): number | null => {
  if (!value) return null
  const parsed = parseFloat(value)
  return isNaN(parsed) ? 0 : parsed
}

/**
 * Converts the value coming from workflow expression (String) to an EntityId
 */
export const convertEntityFromWorkflowValue = (stringValue: string): EntityId | null => {
  if (!stringValue) return null
  const asNumber = parseInt(stringValue, 10)
  return isNaN(asNumber) ? stringValue : asNumber
}
